import type { FaireProductEntity } from "../../entity_types/product";

export const p_kk73dtwgbj: FaireProductEntity = {
  token: "p_kk73dtwgbj",
  type: "product",
  name: "Tinted Lip Shimmer | Moisturize | Tinted Lip Balm",
  brandToken: "b_7lde9s8e6u",
  brandName: "New Day Organics LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/21a6d9094d7ce6345301c963edd20765ce41b9b178e2e6e70ef91e34ef554278.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8471c102e48e08604bfa9400180219f6b35d956bd20fd6dcaa259c7522963a2d.jpeg",
    "https://cdn.faire.com/fastly/8fec44832dc3cee67c7e0086c615fe46ddb9ea295724046e811749290c960b05.jpeg",
    "https://cdn.faire.com/fastly/8233392915eaf16a984192069db11e986b50d56bbc6e2a51ab92c700cb94052f.jpeg",
    "https://cdn.faire.com/fastly/d83b9b2f8a143b645e92a7cd7830d2654bc9ed17312e45d665c6c08cd0bf5a58.jpeg",
    "https://cdn.faire.com/fastly/64c2e0d02a194584b1713a1f55ae4bfd27282b654f087adb6ad21199f10e040c.jpeg",
    "https://cdn.faire.com/fastly/76a2486b7ad445778dacb0835ee5fa078d1355c6619b97f854adb38322191d8b.jpeg",
    "https://cdn.faire.com/fastly/3133e648465ca12e20470e8a4bf5f3134fee671ffb6ee8fba5a5dc3d360125ba.jpeg",
    "https://cdn.faire.com/fastly/3b010e8ea37d6a469fe4a295e9547f8a716321a5304f67cc6896f1afb23ad655.jpeg",
    "https://cdn.faire.com/fastly/85b53a044267b39cef10656db2368e7bd25166eb2ff16f91848ca5b4e27f318c.jpeg",
  ],
  priceDollars: 8.31,
  description:
    "Tinted Lip Shimmer | Moisturize | Tinted Lip Balm | Natural Sheer Lipstain | Peppermint | Organic Lipstick | Lip Balm | Lip Tint\nThese naturally-tinted lip shimmers come in 6 gorgeous colors and are full of amazing lip conditioning ingredients like shea and cocoa butter.\n\nOur Tinted Lip Shimmers are one of our bestsellers- for good reasons! They…\n1) provide long-lasting, SHEER color with a hint of shimmer for day to evening wear.\n\n2) are packed with anti-oxidant-rich organic sunflower oil and vitamin E-rich organic castor oil to protect, soothe and moisturize your lips all day long!\n\n3) are scented in a peppermint-orange scent from essential oils.\n\n• Coral Reef\n• Pink Slippers\n• Red Raspberry\n• Plumberry\n• Rose Blush\n• Bordeaux\nThis is an original formulation that is handmade and hand poured in small batches to ensure your order is fresh.\n\n0.07 oz Tinted Lip Shimmer",
  tags: [],
  msrpDollars: 13.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:15.689Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
